import React, { createContext, useContext, useEffect, useState,ReactNode } from 'react';
import api from '../api'; 

type FilterData = Record<string, any> | null;

interface FilterContextType {
  filtersData: FilterData;
}

const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const useFilterData = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error("useFilterData must be used within a FilterProvider");
  }
  return context;
};

interface FilterProviderProps {
  children: ReactNode;
}

export const FilterProvider = ({ children }: FilterProviderProps) => {
  const [filtersData, setFiltersData] = useState<FilterData>(null);

  useEffect(() => {
    const fetchFilters = async () => {
      try {
        const response: any = await api("/get-filters-data", {
          method: "GET",
        });

        setFiltersData(response);
      } catch (err) {
        console.error("Failed to fetch filters data:", err);
      }
    };

    // Initial fetch on load
    fetchFilters();

    // Set interval to refetch every hour
    const interval = setInterval(fetchFilters, 60 * 60 * 1000);

    // Cleanup on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <FilterContext.Provider value={{ filtersData }}>
      {children}
    </FilterContext.Provider>
  );
};